import "./savingsAccountsOffersViewCardModal.scss";
// vendors
import React from 'react';
import PropTypes from 'prop-types';
import { i18n } from 'core/i18n';
const { formatText, FormattedText, FormattedTextWithNamedVariables, getNamedVariables } = i18n;
// components
import OKModal from 'components/commons/OKModal/OKModal';
// constants
import { POE_KEYS } from "../../../contractsView/components/Step1ContractSavings/constants/poeKeys";

const BASE_CLASSNAME = 'savings-accounts-offers-view-card-modal';

const SavingsAccountsOffersViewCardModal = ({ card, onClose, rateExamples }) => {
    const { accountRate, accountConfig, flowId } = card;
    const getRateExample = ({ superIndex, example, accountConfig }) => {
        const exampleNamedValues = getNamedVariables(example, { ...accountConfig, superIndex });
        return (
            <li className={`${BASE_CLASSNAME}__examples-list-item`} key={superIndex}>
                <FormattedTextWithNamedVariables value={example} namedVariables={exampleNamedValues} />
            </li>
        )
    }

    const getRatesExamples = () => {
        const isDoubleRate = !!accountRate.doubleRate;
        const simpleRateExample = getRateExample(rateExamples[accountRate.simpleRate.superIndex - 1])
        const doubleRateExample = isDoubleRate && getRateExample(rateExamples[accountRate.doubleRate.superIndex - 1])
        return (
            <React.Fragment>
                {simpleRateExample}
                {doubleRateExample}
            </React.Fragment>
        )
    }

    const getRates = () => {
        const poeKeys = POE_KEYS[flowId];
        return (
            <React.Fragment>
                <li>
                    <FormattedTextWithNamedVariables
                        value={poeKeys.profitabilities[0].rate}
                        namedVariables={getNamedVariables(poeKeys.profitabilities[0].rate, { ...accountConfig, superIndex: accountRate.simpleRate.superIndex })} />
                </li>
                <li>
                    <FormattedTextWithNamedVariables
                        value={poeKeys.profitabilities[0].condition}
                        namedVariables={getNamedVariables(poeKeys.profitabilities[0].condition, { ...accountConfig })} />
                </li>
                {
                    accountRate.doubleRate && (
                        <React.Fragment>
                            <li>
                                <FormattedTextWithNamedVariables
                                    value={poeKeys.profitabilities[1].rate}
                                    namedVariables={getNamedVariables(poeKeys.profitabilities[1].rate, { ...accountConfig, superIndex: accountRate.doubleRate.superIndex })} />
                            </li>
                            <li>
                                <FormattedTextWithNamedVariables
                                    value={poeKeys.profitabilities[1].condition}
                                    namedVariables={getNamedVariables(poeKeys.profitabilities[1].condition, { ...accountConfig })} />
                            </li>
                        </React.Fragment>
                    )
                }
            </React.Fragment>
        )
    }

    const buildModalContent = () => (<section className={BASE_CLASSNAME}>
        <h4 className={`${BASE_CLASSNAME}__sectionTitle`}>
            <FormattedText value="contractsView-contractsView_accountSavingProfitability" />
        </h4>
        <ul className={`${BASE_CLASSNAME}__info-list`}>
            {getRates()}
        </ul>
        {card.accountTexts.ADVANTAGE.length > 0 && (
            <div className={`${BASE_CLASSNAME}__dynamicListSection`}>
                <h4 className={`${BASE_CLASSNAME}__sectionTitle`}>
                    <FormattedText value="contractsView-contractsView_accountSavingAdvantages" />
                </h4>
                <ul className={`${BASE_CLASSNAME}__info-list`}>
                    {card.accountTexts.ADVANTAGE.map((advantage, index) => (
                        <li key={index}>{advantage}</li>
                    ))}
                </ul>
            </div>
        )}
        {
            card.accountTexts.CONDITION.length > 0 && (
                <div className={`${BASE_CLASSNAME}__dynamicListSection`}>
                    <h4 className={`${BASE_CLASSNAME}__sectionTitle`}>
                        <FormattedText value="contractsView-contractsView_accountSavingConditions" />
                    </h4>
                    <ul className={`${BASE_CLASSNAME}__info-list`}>
                        {card.accountTexts.CONDITION.map((condition, index) => (
                            <li key={index}>{condition}</li>
                        ))}
                    </ul>
                </div>
            )
        }
        <section className={`${BASE_CLASSNAME}__examples-section`}>
            <ul className={`${BASE_CLASSNAME}__examples-list`}>
                {getRatesExamples()}
            </ul>
            <ul className={`${BASE_CLASSNAME}__examples-list`}>
                {
                    card.accountTexts.REPRESENTATIVE_EXAMPLE.map((example, index) => (
                        <li className={`${BASE_CLASSNAME}__examples-list-item`} key={index}>{example}</li>
                    ))
                }
            </ul>
        </section>
    </section>
    )
    return (
        <OKModal
            content={buildModalContent()}
            footerType="default"
            isOpen={true}
            onCloseCallback={onClose}
            title={formatText('accountOffersFlow-accountOffersFlow_savingAccountBannerTitle')}
            titleAlignment="center"
            size="large"
            contentOverflow="auto"
        />
    );
};

SavingsAccountsOffersViewCardModal.propTypes = {
    card: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    rateExamples: PropTypes.array.isRequired,
};

export default SavingsAccountsOffersViewCardModal;
